import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilityService } from '../../services/utility.service';
import { ClientService } from '../../services/client.service';
import { FilterService } from '../../services/filter.service';
import { AddSiteComponent } from '../add-site/add-site.component';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { SiteAssetsComponent } from '../site-assets/site-assets.component';
@Component({
  selector: 'site-dashboard',
  templateUrl: './site-dashboard.component.html',
  styleUrls: ['./site-dashboard.component.scss']
})
export class SiteDashboardComponent implements OnInit {

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['title', 'address', 'locate', 'asset', 'action'];
  sort: MatSort;
  paginator: MatPaginator
  filterActive: boolean = false
  afterFilter
  siteList = []
  isSpinnerId
  isSpinner = false
  searchText


  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  constructor(
    public _utilityService: UtilityService,
    public _clientService: ClientService,
    public _filter: FilterService
  ) {
    this.dataSource = new MatTableDataSource();
  }


  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit() {
    this.getSites()
  }


  // UTILITY


  // Update data in table dynamically
  updateData(data) {
    console.log("UPDATING DATA = ", data)
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'what3words': return item.what3words.what3words;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    if (this.siteList && !this.siteList.length) {
      this.filterActive = true;
      this.afterFilter = {
        title: "No Sites!",
        data: "Sorry, no sites added yet"
      }
    } else this.filterActive = false
    console.log('SETTING SORT TO = ', this.dataSource.sort)
    console.log('SETTING paginator TO = ', this.dataSource.paginator)
  }


  // Search on site tile, address and what3words
  filter(searchText) {
    this.afterFilter = null
    this.filterActive = false;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.updateData(this.siteList);
      return;
    }
    console.log("filter Time pass data..", this.siteList)
    let tempDataSource = this._filter.filter(searchText, this.siteList, ['title', 'addressTitle', 'locate'], 'asset');
    this.updateData(tempDataSource)
    // console.log("tempDataSource-->", this.tempDataSource, this.loading, this.filterActive);
    if (tempDataSource.length <= 0) {
      this.filterActive = true;
      this.afterFilter = {
        title: "No Sites!",
        data: "Sorry, no sites matched your search"
      }
    }


  }



  // Add or edit site
  addSite() {
    let obj = {
      type: 'asset',
      title: 'Add Site'
    }
    const dialogRef = this._utilityService.commonDialogBoxOpen(AddSiteComponent, obj, "70vw", "70vh")
      .afterClosed().subscribe((data) => {
        if (data == undefined) return
        else if (data) {
          // console.log("add aseet-type model reponse data here ....", data.data.assettype)
          this.getSites()
          this._utilityService.handleSnackBar({ msg: "Site added successfully!", button: "Ok" })
        }
      }, (error) => {
        console.log("some thing wrong accident submsion fail...", error)
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
      })

  }

  // Edit site details
  editSite(siteData) {
    let obj = {
      type: 'asset',
      title: 'Edit Site',
      siteData: siteData
    }
    const dialogRef = this._utilityService.commonDialogBoxOpen(AddSiteComponent, obj)
      .afterClosed().subscribe((data) => {
        console.log("WHAT IS IN THE DATA", data);

        if (data == undefined) return
        else if (data) {
          // console.log("add aseet-type model reponse data here ....", data.data.assettype)
          this.getSites()
          this._utilityService.handleSnackBar({ msg: "Site updated successfully!", button: "Ok" })
        }
      }, (error) => {
        console.log("some thing wrong accident submsion fail...", error)
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
      })
  }

  // Delete site
  deleteSite(siteId) {
    console.log("This is the site Id", siteId);
    const dialogRef = this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, "site")
      .afterClosed().subscribe((confirm) => {
        if (confirm == '') return
        else if (confirm == 'yes') {
          console.log("WHat is in the confirm", confirm);
          let obj = {
            siteId: siteId,
            locationType: 'asset'
          }
          this._clientService.deleteLocation(JSON.stringify(obj))
            .subscribe((data) => {
              console.log('Hello response data here ==>', data)
              this.getSites()
              this._utilityService.handleSnackBar({ msg: "Site deleted successfully!", button: "Ok" })
            }, (error) => {
              console.log('delete accident some error occure!!!', error)
              this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
            })
        }
      })
  }



  displayAssetList(element) {
    console.log("Single site details", element);
    const dialogRef = this._utilityService.commonDialogBoxOpen(SiteAssetsComponent, element, "70vw", "70vh")
      .afterClosed().subscribe((confirm) => {
        // if (confirm == '') return
      })
  }

  // API CALL


  // Get site list for asset
  getSites() {
    let obj = {
      locationType: 'asset'
    }
    this._clientService.getSiteList(JSON.stringify(obj)).subscribe((response) => {
      console.log("Response of site list", response);
      this.siteList = response

      this.updateData(this.siteList)
    }, err => {
      console.log("Error while get sites list", err);
      this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
    })

  }

  downloadSitePrint(data) {
    console.log("THIS IS THE DATA", data);
    this.isSpinnerId = data._id
    this.isSpinner = true
    const obj = {
      siteTitle: data.title,
      what3words: data.what3words,
      address: data.addressTitle,
      assetList: data.assetList
    }
    this._clientService.downloadSitePrint(obj).subscribe((pdfData) => {
      if (pdfData) {
        console.log("PDF DATA OF SINGLE SITE", pdfData);
        this._utilityService.handleSnackBar({ msg: "Site File Download Successfully", button: "Ok" })
      }
      this.isSpinner = false
      this.isSpinnerId = null
    }, error => {
      console.log("ERROR WHILE DOWNLOAD PDF", error);
      this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
      this.isSpinner = false
      this.isSpinnerId = null
    })
  }


}
